if (!customElements.get('savage-nav')) {
  customElements.define('savage-nav', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      if (!this.details || this.closest('.js__header__clone')) return;
      this.summary = this.details.querySelector('summary');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse' || !matchMedia('(hover: hover)').matches) return;
        clearTimeout(this.closeTimer);
        this.open();
      }, options);
      this.addEventListener('pointerleave', () => {
        this.closeTimer = setTimeout(() => {
          if (!this.contains(document.activeElement)) this.close();
        }, 160);
      }, options);
      this.addEventListener('focusin', event => {
        if (!this.restoringFocus && event.target.matches(':focus-visible')) this.open();
      }, options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) this.close();
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.details.open) {
          event.preventDefault();
          event.stopPropagation();
          this.close();
          this.restoringFocus = true;
          this.summary.focus();
          this.restoringFocus = false;
        }
        if (event.key === 'ArrowDown' && event.target === this.summary) {
          event.preventDefault();
          this.open();
          this.querySelector('.savage-nav__panel a')?.focus();
        }
      }, options);
      this.details.addEventListener('toggle', () => {
        if (this.details.open) this.closeOthers();
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) this.close();
      }, options);
      window.addEventListener('resize', () => this.close(), options);
      ['theme:cart:open', 'theme:search:open', 'theme:drawer:open'].forEach(name => {
        document.addEventListener(name, () => this.close(), options);
      });
    }
    open() {
      clearTimeout(this.closeTimer);
      this.closeOthers();
      this.details.open = true;
    }
    closeOthers() {
      this.closest('nav')?.querySelectorAll('savage-nav').forEach(item => {
        if (item !== this) item.close?.();
      });
    }
    close() {
      clearTimeout(this.closeTimer);
      if (this.details) this.details.open = false;
    }
    disconnectedCallback() {
      clearTimeout(this.closeTimer);
      this.controller?.abort();
    }
  });
}
